import api from "./api";
import { useEffect, useState } from "react";
import { useUserSuperEmpresa } from "../Context/AuthContext";


export const useSucursales = () => {
  const { Token } = useUserSuperEmpresa();

  const getSucursales = async (params = {}) => {
    try {
      const { data } = await api.get("/branches", { 
        params,
        headers: {
          Authorization: `Bearer ${Token}`, // enviamos token
        }
      });
      return data;
    } catch (error) {
      throw error.response?.data?.message || "Error al obtener ingresos";
    }
  };

  const postSucursales = async (params = {}) => {
    try {
      const { data } = await api.post("/branches/store", params, {
        headers: {
          Authorization: `Bearer ${Token}`, // enviamos token
        },
      });
      return data.data;
    } catch (error) {
      throw error.response?.data?.message || "Error al crear ingreso";
    }
  };

  const eliminarSucursal = async (id) => {
    try {
      const { data } = await api.delete(`/branches/delete/${id}`, {
        headers: { Authorization: `Bearer ${Token}` },
      });
      return data;
    } catch (error) {
      throw error.response?.data?.message || "Error al eliminar el usuario";
    }
  };
  return { getSucursales, postSucursales, eliminarSucursal };
};



export const useGetSucursal = () => {
  const { Token } = useUserSuperEmpresa();
  const { getSucursales } = useSucursales();
  const [sucursales, setSucursales] = useState([]);
  const [loadings, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchSucursales = async () => {
    setLoading(true);
    try {
      const data = await getSucursales();
      setSucursales(data);
    } catch (err) {
      setError(err.response?.data?.message || "Error al obtener sucursales");
    } finally {
      setLoading(false);
    }
  };

  // Cargar al montar
  useEffect(() => {
    if (Token) fetchSucursales();
  }, [Token]);

  // ✅ Retorna la función refetch
  return { sucursales, loadings, error, refetch: fetchSucursales };
};
